import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';

import ContainerTranslation from "../partials/ContainerTranslation";
import { fetchEightD,extractEightD} from '../../actions/eightD';

import Progress from '../partials/Progress';

class EightDView extends React.Component {

  fourth = React.createRef();

  constructor(props) {
    super(props);
    this.props.fetchEightD(this.props.match.params.id);
  }


  handleExtract(){
    this.props.extractEightD(this.props.match.params.id);
  } 

  renderSubSection(field,path){
    return (
      <>
        <p className="bloc-title" style={{ marginBottom: 0 }}>
          {field}
        </p>
        <p className="bloc-content" style={{ color: '#181E23' }}>
          {_.get(this.props.eightD.content,path + '.' + field)}
          <br />
        </p>
      </>
    )
  }

  renderSection(fields,path){
    return (       
      <div className={"formulaire wide"}>      
        <h3>{path}</h3>
        <div className="bloc">
        {_.map(fields,(field)=>{
          return (
            <>
            {this.renderSubSection(field,path)}
            </>
            )
        })}
        </div>
      </div> 
    )
  }


  render() {

    let route = null;

    if (Object.keys(this.props.eightD).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    }

    if (this.props.eightD.authorization.write) {
      route = "/8D/edit/" + this.props.eightD._id
    };

    // this.props.eightD.validationInformation
    return (
      <>
      <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
      <div className="dashboard">
        {Object.keys(this.props.eightD).length === 0 ?
          <h3 style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</h3>
          :
          <div>
            <div className="dashboard-header">
              <div style={{width: 'calc(100% - 200px)'}}>
                <Progress progression={this.props.eightD.progression.globalPercentage} 
                            validationInformation = {{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}} 
                            title = {this.props.eightD.content.information.title}
                            kind = "EightD"
                />
              </div>
              <div style={{flex : 1}}> 
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                {route ?
                  <Link className="primary-btn filling" style={{ width: "110px", height: "48px" }} to={route}>
                    Edit 8D
                  </Link>
                  :
                  null
                }
                  <button onClick={this.handleExtract.bind(this)} className="primary-btn filling" style={{ width: "156px", height: "48px", marginTop: "20px" }}>
                    <div>Extraire le 8D</div>
                  </button>
                </div>
              </div>  
            </div>
            
            {this.props.eightD.content ?
              <div className="dashboard-content">

                <div className="col-1-3">


                  {/*INFORMATION*/}
                  <div className="bloc">
                    <ContainerTranslation id={['content'] + "." + ['information'] + ".title"} tag={"span"} />
                    <p className="bloc-content">
                      <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['update-date']} /> {this.props.eightD.updatedAt.slice(0, 10)}
                    </p>


                    <p className="bloc-title" style={{ marginBottom: 0 }}>Nom du programme</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>
                      <Link to={"/program/" + this.props.eightD.program._id}>   
                        {this.props.eightD.program.content.information.name}
                      </Link>
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Titre du problème</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>         
                      {this.props.eightD.content.information.title}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Source</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>         
                      {this.props.eightD.content.information.source}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Date d'identification du problème</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>         
                      {this.props.eightD.content.information["problem-detection-date"]}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Date d'initiation du rapport</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>         
                      {this.props.eightD.content.information["creation-date"]}
                    </p>

                    <p className="bloc-title" style={{ marginBottom: 0 }}>Est-ce que le client est notifié</p>
                    <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>         
                      {this.props.eightD.content.information["is-client-informed?"]}
                    </p>

                  </div>

            
                </div>

                {/*LEFT PART*/}

                <div className="col-2-3">


                <div className="bloc">
                    <span>D1 - Équipe</span>
                    {this.props.eightD.content['team']['members'].map((member, i) => <div key={"member-" + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Nom : {member.name} Role : {member.role}</p>
                        <p>-----------------------------------------------------------------</p>
                      </div>
                    </div>)}
                  </div>

                  <div className="bloc">
                  <span>D2 - Description du problème</span>
                    <div style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Quoi : {this.props.eightD.content['problem-description']['description']['what']}</p>
                        <p>Qui : {this.props.eightD.content['problem-description']['description']['who']}</p>
                        <p>Où : {this.props.eightD.content['problem-description']['description']['where']}</p>
                        <p>Quand : {this.props.eightD.content['problem-description']['description']['when']}</p>
                        <p>Pourquoi : {this.props.eightD.content['problem-description']['description']['why']}</p>
                        <p>Combien : {this.props.eightD.content['problem-description']['description']['how-much']}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bloc">
                  <span>D3 - Actions immédiates: Correction / confinement </span>
                    {this.props.eightD.content['immediate-actions']['actions'].map((action, i) => <div key={"immediate-actions-actions-" + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Action : {action.action} Personne en charge : {action.author}</p>
                        <p>Date de cloture attendue : {action['closure-date']} DDC : {action['DDC']}</p>   
                        <p>-----------------------------------------------------------------</p>                   
                      </div>
                    </div>)}
                  </div>


                  <div className="bloc">
                  <span>D4 - Analyse des causes </span>
                    {this.props.eightD.content['root-cause-analysis']['causes'].map((cause, i) => <div key={"root-cause-analysis-cause-" + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Action : {cause.cause} </p>  
                        <p>-----------------------------------------------------------------</p>                   
                      </div>
                    </div>)}
                  </div>

                  <div className="bloc">
                  <span>D5 - Actions correctives (Éliminitation des causes)</span>
                    {this.props.eightD.content['corrective-action']['actions'].map((action, i) => <div key={"corrective-action-actions-" + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Action : {action.action} Personne en charge : {action.author}</p>
                        <p>Date de cloture attendue : {action['closure-date']} DDC : {action['DDC']}</p>   
                        <p>-----------------------------------------------------------------</p>                   
                      </div>
                    </div>)}
                  </div>


                  <div className="bloc">
                  <span>D7 - Prévention de la recurrence</span>
                    {this.props.eightD.content['preventive-action']['actions'].map((action, i) => <div key={'preventive-action-actions-' + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Action : {action.action} Personne en charge : {action.author}</p>
                        <p>Date de cloture attendue : {action['closure-date']} DDC : {action['DDC']}</p>   
                        <p>-----------------------------------------------------------------</p>                   
                      </div>
                    </div>)}
                  </div>

                  <div className="bloc">
                  <span>D8 - Clôture / Remerciements</span>
                    {this.props.eightD.content['conclusion']['actions'].map((action, i) => <div key={'conclusion-actions' + i} style={{ display: 'block' }}>
                      <div className="bloc-content">
                        <p>Action : {action.action} Personne en charge : {action.author}</p>
                        <p>Date de cloture attendue : {action['closure-date']} DDC : {action['DDC']}</p>   
                        <p>-----------------------------------------------------------------</p>                   
                      </div>
                    </div>)}
                  </div>


                </div>


              </div>
              :
              null
            }

          </div>
        }
      </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  message: state.eightD.message,
  eightD: state.eightD.eightD,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchEightD,extractEightD
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(EightDView)));
